/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  ExternalLink,
  AlertCircle,
  CheckCircle,
  Check,
  X,
  RefreshCw,
  Info,
} from "lucide-react";
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";

export default function ActivationSawa9ly({ close }) {
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const account = useSelector((state) => state.AccountReducer);
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const products = useSelector((state) => state.ProductsReducer || []);
  const [isSawa9lyActive, setIsSawa9lyActive] = useState(false);
  const { t } = useTranslation();
  const [data, setData] = useStoreFormDraft(store);

  useEffect(() => {
    if (store) {

      setIsSawa9lyActive(Boolean(store.sawa9lyToken?.trim()));
    }
  }, [store]);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.sawa9ly.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.sawa9ly.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `rgba(0,0,0,0.7)`,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleRedirect = () => {
    window.open("https://sawa9ly.app/user/profile#foorweb", "_blank");
  };

  const handleDeactivate = async () => {
    const result = await showAlert(
      "warning",
      t("servicePageActivation.sawa9ly.alerts.deactivateTitle"),
      t("servicePageActivation.sawa9ly.alerts.deactivateText"),
      true,
      t("servicePageActivation.sawa9ly.alerts.deactivateConfirmButton")
    );

    if (!result.isConfirmed) {
      return;
    }

    try {
      setLoading(true);

      const updatedData = { ...data, sawa9lyToken: "" };
      await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
      dispatch(applyStoreDraft(store, updatedData));

      setLoading(false);
      setIsSawa9lyActive(false);
      setData(updatedData);

      await showAlert(
        "success",
        t("servicePageActivation.sawa9ly.alerts.deactivatedSuccess")
      );
      close();
      await apicache(account, products);
    } catch (error) {
      setLoading(false);
      await showAlert(
        "error",
        t("servicePageActivation.sawa9ly.alerts.deactivationErrorTitle"),
        t("servicePageActivation.sawa9ly.alerts.deactivationErrorText")
      );
      console.error("Error deactivating Sawa9ly:", error);
    }
  };

  return (
    <div className="min-h-[400px] h-fit p-6">
      <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center">
            {isSawa9lyActive ? (
              <CheckCircle className="ml-2" size={20} />
            ) : (
              <AlertCircle className="ml-2" size={20} />
            )}
            {t("servicePageActivation.sawa9ly.title")}
          </h3>
          <p className="text-gray-600 dark:!text-gray-400">
            {t("servicePageActivation.sawa9ly.description")}
          </p>
        </div>

        {/* Service Status Indicator */}
        <div
          className={`mb-4 p-3 rounded-lg border ${
            isSawa9lyActive
              ? "border-green-200 bg-white dark:!bg-[#181819] dark:!border-green-700"
              : "border-gray-200 bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d]"
          }`}
        >
          <div className="flex items-center gap-x-2">
            <div
              className={`w-3 h-3 rounded-full mr-2 ${
                isSawa9lyActive ? "bg-green-500" : "bg-gray-400"
              }`}
            ></div>
            <span
              className={`text-sm font-medium dark:!text-gray-300 ${
                isSawa9lyActive
                  ? "text-green-700 dark:!text-green-300"
                  : "text-gray-700 dark:!text-gray-400"
              }`}
            >
              {isSawa9lyActive
                ? t("servicePageActivation.sawa9ly.statusActive")
                : t("servicePageActivation.sawa9ly.statusInactive")}
            </span>
          </div>
        </div>

        {/* Content based on activation status */}
        {isSawa9lyActive ? (
          <div className="space-y-4">
            {/* Success Message */}
            <div className="p-4 rounded-lg border border-green-100 bg-green-50 dark:!bg-[#181819] dark:!border-green-700">
              <div className="flex items-start">
                <CheckCircle
                  size={20}
                  className="text-green-600 dark:!text-green-400 ml-2 mt-0.5"
                />
                <div>
                  <h4 className="font-medium text-green-800 dark:!text-green-300 mb-1">
                    {t("servicePageActivation.sawa9ly.activated.title")}
                  </h4>
                  <p className="text-sm text-green-700 dark:!text-green-400">
                    {t("servicePageActivation.sawa9ly.activated.description")}
                  </p>
                </div>
              </div>
            </div>

            {/* Deactivate Button */}
            <button
              onClick={handleDeactivate}
              disabled={loading}
              className={`w-full px-6 py-3 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors flex items-center justify-center ${
                loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("servicePageActivation.sawa9ly.deactivating")}
                </>
              ) : (
                <>
                  <X className="ml-2" size={18} />
                  {t("servicePageActivation.sawa9ly.deactivateButton")}
                </>
              )}
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            {/* Activation Instructions */}
            <div className="p-4 rounded-lg border border-purple-100 bg-[#fcf6ff] dark:!bg-[#181819] dark:!border-purple-700">
              <h4 className="font-medium text-[#9e68ba] dark:!text-[#b47ed6] mb-2 flex items-center">
                <Info size={18} className="ml-2" />
                {t("servicePageActivation.sawa9ly.instructions.title")}
              </h4>
              <p className="text-sm text-gray-700 dark:!text-gray-400">
                {t("servicePageActivation.sawa9ly.instructions.part1")}{" "}
                <span className="font-semibold text-[#9e68ba] dark:!text-[#b47ed6]">
                  {t("servicePageActivation.sawa9ly.instructions.platform")}
                </span>
                ، {t("servicePageActivation.sawa9ly.instructions.part2")}
              </p>
            </div>

            {/* Redirect Button */}
            <button
              onClick={handleRedirect}
              className="w-full px-6 py-3 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors flex items-center justify-center"
            >
              <ExternalLink size={18} className="ml-2" />
              {t("servicePageActivation.sawa9ly.activateButton")}
            </button>
          </div>
        )}

        {/* Tips Section */}
        <div className="mt-6 p-4 rounded-lg border border-yellow-100 bg-yellow-50 dark:!bg-[#181819] dark:!border-[#3c3a3d]">
          <h4 className="font-medium text-lg text-yellow-800 dark:!text-yellow-300 mb-2 flex items-center">
            <Info size={18} className="ml-2" />
            {t("servicePageActivation.sawa9ly.tips.title")}
          </h4>
          <ul className="text-sm text-gray-700 dark:!text-gray-400 space-y-2 mr-5 list-disc">
            <li>{t("servicePageActivation.sawa9ly.tips.tip1")}</li>
            <li>{t("servicePageActivation.sawa9ly.tips.tip2")}</li>
            <li>{t("servicePageActivation.sawa9ly.tips.tip3")}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
